import ScheduleIndex from "@/SchedulerV2/ScheduleIndex.vue";

export default [
  {
    path: "/",
    name: "SchedulePage",
    component: ScheduleIndex,
    meta: {
      permissionRoles: ["jobs"]
    }
  }
];
